module.exports = __webpack_public_path__ + "static/media/2.63da4d58.svg";